
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {IdempotencyInfoGetExpiredResponse} from './IdempotencyInfoGetExpiredResponse';

/**
 * IdempotencyInfoGetExpiredRequest struct
 */
class IdempotencyInfoGetExpiredRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Date=} currentTime
   * @constructor
   */
  constructor (parent = new Request(), currentTime = new Date(0)) {
    super()
    super.copy(parent)
    this.CurrentTime = currentTime
  }

  /**
   * Copy struct (shallow copy)
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @param {!IdempotencyInfoGetExpiredRequest} other Other struct
   * @returns {!IdempotencyInfoGetExpiredRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.CurrentTime != null) {
      if (other.CurrentTime instanceof Date) {
        this.CurrentTime = new Date(other.CurrentTime.getTime())
      } else {
        this.CurrentTime = new Date(Math.round(other.CurrentTime / 1000000))
      }
    } else {
      this.CurrentTime = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @returns {!IdempotencyInfoGetExpiredRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new IdempotencyInfoGetExpiredRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new IdempotencyInfoGetExpiredRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @param {!IdempotencyInfoGetExpiredRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof IdempotencyInfoGetExpiredRequest)) {
      throw new TypeError('Instance of IdempotencyInfoGetExpiredRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      CurrentTime: ((this.CurrentTime != null) ? (this.CurrentTime.getTime() * 1000000) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return IdempotencyInfoGetExpiredRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!IdempotencyInfoGetExpiredRequest} other Object value
   * @returns {!IdempotencyInfoGetExpiredRequest} Created struct
   */
  static fromObject (other) {
    return new IdempotencyInfoGetExpiredRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return IdempotencyInfoGetExpiredRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!IdempotencyInfoGetExpiredRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4227
  }
}

export { IdempotencyInfoGetExpiredRequest };

/**
 * Fast Binary Encoding IdempotencyInfoGetExpiredRequest field model
 */
class FieldModelIdempotencyInfoGetExpiredRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.CurrentTime = new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.CurrentTime.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.CurrentTime.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelIdempotencyInfoGetExpiredRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4227
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrentTime.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CurrentTime.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrentTime.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!IdempotencyInfoGetExpiredRequest} fbeValue Default value, defaults is new IdempotencyInfoGetExpiredRequest()
   * @returns {!IdempotencyInfoGetExpiredRequest} IdempotencyInfoGetExpiredRequest value
   */
  get (fbeValue = new IdempotencyInfoGetExpiredRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!IdempotencyInfoGetExpiredRequest} fbeValue IdempotencyInfoGetExpiredRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrentTime.fbeSize) <= fbeStructSize) {
      fbeValue.CurrentTime = this.CurrentTime.get()
    } else {
      fbeValue.CurrentTime = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrentTime.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {!IdempotencyInfoGetExpiredRequest} fbeValue IdempotencyInfoGetExpiredRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelIdempotencyInfoGetExpiredRequest}
   * @param {IdempotencyInfoGetExpiredRequest} fbeValue IdempotencyInfoGetExpiredRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.CurrentTime.set(fbeValue.CurrentTime)
  }
}

export { FieldModelIdempotencyInfoGetExpiredRequest };

/**
 * Fast Binary Encoding IdempotencyInfoGetExpiredRequest model
 */
class IdempotencyInfoGetExpiredRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelIdempotencyInfoGetExpiredRequest(this.buffer, 4)
  }

  /**
   * Get the IdempotencyInfoGetExpiredRequest model
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!FieldModelIdempotencyInfoGetExpiredRequest} model IdempotencyInfoGetExpiredRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return IdempotencyInfoGetExpiredRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelIdempotencyInfoGetExpiredRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @param {!IdempotencyInfoGetExpiredRequest} value IdempotencyInfoGetExpiredRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @param {!IdempotencyInfoGetExpiredRequest} value IdempotencyInfoGetExpiredRequest value, defaults is new IdempotencyInfoGetExpiredRequest()
   * @return {!object} Deserialized IdempotencyInfoGetExpiredRequest value and its size
   */
  deserialize (value = new IdempotencyInfoGetExpiredRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new IdempotencyInfoGetExpiredRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new IdempotencyInfoGetExpiredRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!IdempotencyInfoGetExpiredRequestModel}
   * @param {!number} prev Previous IdempotencyInfoGetExpiredRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { IdempotencyInfoGetExpiredRequestModel };
IdempotencyInfoGetExpiredRequest.__has_response = true;
IdempotencyInfoGetExpiredRequest.__response_class = IdempotencyInfoGetExpiredResponse;
